export class GeocodingLocation {
  location: string;
  city: string;
  county: string;
  name: string = null;
  website: string = null;
  countryCode: string = null;
  placeId: string;
  latitude: number;
  longitude: number;
}
